




























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import SearchResultsComponent from '@/pages/search/components/search-results-component.vue';
import Toast from '@/components/display/toast.vue';
import { SearchResults } from '@/api';

@Component({
	components: { SearchResultsComponent },
})
export default class SearchBar extends Vue {
	@Prop({ default: false })
	public hasSearched!: boolean;

	@Prop({ default: false })
	public canDarken!: boolean;

	@Prop({ default: false })
	public inlineSearch!: boolean;

	public searchValue: string = '';
	public showRecentSearches: boolean = false;
	public recentSearches: string[] = [];

	public loadingInline: boolean = false;

	private searchInputElement!: HTMLInputElement;
	private searchResultsComponent?: SearchResultsComponent;
	private toast: Toast = new Toast();

	mounted() {
		this.searchValue = this.$route?.query?.q?.toString() ?? '';

		this.searchInputElement = <HTMLInputElement>this.$refs.searchInput;
		this.searchResultsComponent = <SearchResultsComponent>this.$refs.searchResults;

		this.updateRecents();
	}

	public shouldShowRecentsBox(): boolean {
		return this.hasRecents() && this.showRecentSearches;
	}

	public hasRecents(): boolean {
		return !!this.recentSearches?.length;
	}

	public showRecents(): void {
		this.updateRecents();
		this.showRecentSearches = true;
	}

	public hideRecents(): void {
		setTimeout(() => (this.recentSearches = []), 200);
		this.showRecentSearches = false;
	}

	public loadRecents(): string[] {
		const recents = localStorage.getItem('recentSearches') ?? '[]';
		try {
			return JSON.parse(recents) ?? [];
		} catch (ex) {}
		return [];
	}

	public updateRecents(): void {
		this.onInput();
		this.recentSearches = this.loadRecents();
		this.recentSearches = this.recentSearches.filter(search =>
			search
				?.trim()
				.toLowerCase()
				.startsWith(this.searchValue?.trim().toLowerCase()),
		);
	}

	public searchRecent(recent: string): void {
		this.searchValue = recent;

		this.submitSearch();
	}

	public clearRecentSearches(): void {
		localStorage.removeItem('recentSearches');
		this.searchValue = '';
		this.updateRecents();
	}

	public get reverseRecentSearches(): string[] {
		return this.recentSearches.reverse();
	}

	public hasSearchResults(): boolean {
		return this.searchResultsComponent != null && this.searchResultsComponent.hasSearchResults();
	}

	public clearSearch(): void {
		this.searchResultsComponent?.clearSearch();
	}

	public submitSearch(): void {
		if (this.searchValue?.trim().length > 0) {
			const recentSearches = this.loadRecents();
			const recentExists = recentSearches.findIndex(
				x => x.trim().toLowerCase() === this.searchValue.trim().toLowerCase(),
			);
			if (recentExists != -1) recentSearches.splice(recentExists, 1);
			recentSearches.push(this.searchValue.trim());
			if (recentSearches.length > 10) recentSearches.splice(0, 1);
			localStorage.setItem('recentSearches', JSON.stringify(recentSearches));

			this.updateRecents();

			this.searchInputElement.blur();
			this.hideRecents();

			if (!this.inlineSearch) {
				this.onSubmitSearch();
				return;
			}

			this.doInlineSearch(this.searchValue.trim());
		}
	}

	private doInlineSearch(searchValue: string): void {
		this.loadingInline = true;

		this.searchResultsComponent?.submitSearch(searchValue, false);

		this.loadingInline = false;
	}

	public hasLoadedResults(results: SearchResults): void {
		if (
			!(
				results?.orgs?.length ||
				results?.sites?.length ||
				results?.users?.length ||
				results?.products?.length ||
				results?.transceivers?.length ||
				results?.sensors?.length ||
				results?.gateways?.length ||
				results?.nodes?.length
			)
		) {
			this.toast.makeToast('No search results found', 'No Search Results', 'warning');
		}
	}

	@Emit('inputChange')
	public onInput(): string {
		return this.searchValue.trim();
	}

	@Emit('submitSearch')
	public onSubmitSearch(): string {
		return this.searchValue.trim();
	}
}
